import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import HVAConversationWidget from './HVAConversationWidget';

interface HVAConversationModalProps {
  show: boolean;
  onHide: () => void;
  agentCode: string;
  agentName: string;
  agentImage?: string;
  onError: (error: Error) => void;
  customer?: string;
  dni?: string;
  debt?: string;
}

const HVAConversationModal: React.FC<HVAConversationModalProps> = ({
  show,
  onHide,
  agentCode,
  agentName,
  agentImage,
  onError,
  customer,
  dni,
  debt
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      contentClassName="border-0"
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-body-emphasis">
          Talk to {agentName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0 pe-4 bg-body">
        <Row className="g-0">
          {/* Columna de la imagen */}
          <Col
            md={3}
            className="p-4 pe-0 d-flex flex-column justify-content-center align-items-center"
          >
            {agentImage && (
              <div
                className="text-center position-sticky"
                style={{ top: '1rem' }}
              >
                <img
                  src={agentImage}
                  alt={agentName}
                  className="img-fluid"
                  style={{
                    width: '100%',
                    maxWidth: '150px',
                    height: 'auto',
                    objectFit: 'cover'
                  }}
                />
              </div>
            )}
          </Col>

          {/* Columna del widget de conversación */}
          <Col md={9} className="p-4" style={{ minHeight: '320px' }}>
            <div>
              <p>
                {customer} <br /> {dni} <br /> {debt}
              </p>
            </div>
            <div>
              <HVAConversationWidget agentId={agentCode} onError={onError} />
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

export default HVAConversationModal;
